import React,{ useState } from 'react'
import styled from 'styled-components';
import { Form } from '../components';
import { ReactComponent as HiringSvg } from '../assets/hiring.svg'
import { NormalContainer } from '../global-styles';
//import emailjs from 'emailjs-com';
//emailjs.init("user_jxJrk65oT85KgZ59BTNJB");

export default function Hire(){

    const [ name, setName] = useState('');
    const [ emailAddress, setEmailAddress ] = useState('');
    const [message, setMessage] = useState('');
    const [ error, setError ] = useState('');

    let isInvalid = name==='' | emailAddress==='';

    const handleSubmit = (event) => {
        event.preventDefault();

        // generate a five digit number for the contact_number variable
        // contact_number = Math.random() * 100000 | 0;
        // these IDs from the previous steps

        const templateParams = {
            "from_name": name,
            "from_email": emailAddress,
            "message": message,
            "contact_number" : Math.random() * 100000 | 0
        };

        // emailjs.sendForm('service_0i5zkha', 'contact_form', templateParams)
        //     .then((result) => {
        //         console.log(`SUCCESS! ${result.text}`);
        //         setEmailAddress('');
        //         setName('');
        //         setError('');
        //     }, function (error) {
        //         console.log('FAILED...', error);
        //         setError(error.message);
        //         setEmailAddress('');
        //         setName('');
        //     });
        console.log(templateParams);
    }


    return(
        <Container>
            <InfoPane>
                <HiringSvg />
            </InfoPane>
            <ContactForm>
                <Form>
                    <Form.Title>Contact Me</Form.Title>
                    {error && <Form.Error>{error}</Form.Error>}

                    <Form.Base onSubmit={handleSubmit} method="POST">
                        <Form.Input
                            type="text"
                            placeholder="Name"
                            value={name}
                            onChange={({ target }) => setName(target.value)}
                        />
                        <Form.Input
                            type="email"
                            placeholder="Email address"
                            value={emailAddress}
                            onChange={({ target }) => setEmailAddress(target.value)}
                        />
                        <Form.TextArea
                            placeholder="Your message here"
                            value={message}
                            onChange={({ target }) => setMessage(target.value)}
                        />
                        <Form.Submit disabled={isInvalid} type="submit" value="Submit" />
                    </Form.Base>
                </Form>
            </ContactForm>
        </Container>
    );
}

const Container = styled(NormalContainer)`
    display: flex;
    max-width: 100%;
    padding: 0;
    box-sizing: border-box;

    @media screen and ( max-width: 1100px){
        flex-direction: column;
        width: 100%;
    }
`;

const InfoPane = styled.div`
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80%;
    background: #25CCF7;
    border-radius: 15px;
    margin: 25px auto;
    border: 1px solid #5f27cd;

    * {
        width: 180px;
        height: 250px;
    }

    @media screen and ( min-width: 800px){
            display: none;
    }

    @media screen and ( min-width: 1100px){
        display: flex;
        max-height: 100%;
        width: 100%;

        * {
            width: 500px;
            height: 560px;
        }
    }
`;

const ContactForm = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    @media screen and ( min-width: 800px){
        max-height: 100%;
    }

`;